/**
 * <s-sticky-buy> — shows a compact add-to-cart bar once the main add-to-cart
 * button has scrolled above the viewport, and hides it again when it returns.
 * The bar's own submit button lives inside the product form, so
 * <s-product-form> handles the add exactly like the main button.
 */
class SStickyBuy extends HTMLElement {
  #observer;

  connectedCallback() {
    const form = this.closest('form');
    const anchor = form?.querySelector('[data-sticky-buy-anchor]');
    if (!anchor) return;

    this.#setVisible(false);
    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.#setVisible(scrolledPast);
    });
    this.#observer.observe(anchor);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
    this.setAttribute('aria-hidden', String(!visible));
  }
}

if (!customElements.get('s-sticky-buy')) {
  customElements.define('s-sticky-buy', SStickyBuy);
}
